<template>
    <section id="theme-selector">
        <h1>Select a Theme!</h1>
        <div id="available-themes">
            <div class="theme" v-for="theme in availableThemes" :class="[`theme-${theme}`, {selected: theme == selectedTheme}]" @click.prevent="selectTheme(theme)">
                <span class="regular-text">A</span>
                <span class="link">A</span>
            </div>
        </div>
        <button @click.prevent="saveTheme">Save Theme</button>
    </section>
</template>


<script>
    import axios from 'axios';

    export default {
        name: 'ThemeSelector',

        data() {
            return {
                availableThemes: [
                    'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i'
                ]
            }
        },

        computed: {
            selectedTheme(){
                return this.$store.state.loggedUserModel.info.theme
            }
        },

        methods: {
            selectTheme(theme){
                this.$set(this.$store.state.loggedUserModel.info, 'theme', theme)
            },

            saveTheme(){
                axios.post('api/member/saveTheme', {
                    theme: this.selectedTheme
                }).then(
                    (response) => {
                        this.$emit('exitThemeSelectMode')
                    }
                )
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ThemeSelector.vue?2feddccc